import { ImageElementType } from 'polotno/model/image-model';

export const inheritAvatarSizeAndPosition = (avatarElement: ImageElementType, presenterWidth: number, presenterHeight: number) => {
    const { x: currentX, y: currentY, width: currentWidth, height: currentHeight } = avatarElement;

    const center = {
        x: currentX + currentWidth / 2,
        y: currentY + currentHeight / 2,
    };

    const avatarMaxWidth = currentWidth;
    const avatarMaxHeight = currentHeight;

    const widthRatio = presenterWidth / avatarMaxWidth;
    const heightRatio = presenterHeight / avatarMaxHeight;

    const maxRatio = Math.max(widthRatio, heightRatio);

    const newWidth = presenterWidth / maxRatio;
    const newHeight = presenterHeight / maxRatio;

    const newX = center.x - newWidth / 2;
    const newY = center.y - newHeight / 2;

    return {
        centerX: center.x,
        centerY: center.y,
        x: newX,
        y: newY,
        width: newWidth,
        height: newHeight,
    };
};
